export const HOME_SLUGS = [
  "reimagining-reconnection",
  "penn-labs",
];

export const projects = [
    {
    slug: "penn-labs",
    title: "Penn Labs",
    category: "Design / Frontend",
    description: "Redesign Penn Clubs frontend to be scalable, usable and consistent",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792899550/8f0ec0d1-d4a6-4c2c-b108-62de8d461385.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792898408/ec9f906a-de22-425e-8dc1-da514f9e9030.png",
    },
    meta: {
      role: "Designer",
      collaborators: "AJ Boyle, Gabe Weng, Shayaan Wadkar, PennClubs team",
      duration: "Oct 2026 - Present",
      tools: "Cursor, React, Canva, Figma",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "More details coming soon!",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792899529/47f37ae6-a533-4e19-936d-8da4753caed0.png",
        caption: "Member filtering and message to members that uses multi-select, based on user feedback",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792899611/1325485f-c17a-459b-ba85-99fe64ca9333.png",
        caption: "Figma prototype for edit club page, the real frontend can scale to screen width",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792899550/8f0ec0d1-d4a6-4c2c-b108-62de8d461385.png",
        caption: "Events calendar & scheduling, enabling club admin to visually organize events without using a third-party app",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1793601468/Screen_Recording_2026-11-02_at_1.34.03_AM.mov",
        caption: "Interactive Tables with adjustable rows",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1793601219/9f2c8206-7e3b-40bf-a351-6859ae5f8e71.png",
        caption: "Applications section",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1793602736/Screen_Recording_2026-11-02_at_1.49.56_AM_online-video-cutter.com.mov",
        caption: "Mobile scale of Applications section, with collapsible panels for greater clarity",
      },
    ],
  },
  {
    slug: "reimagining-reconnection",
    title: "Reimagining Reconnection",
    category: "Product / Design",
    description: "Relationship-building app for SVSD Designathon 2026",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792708272/fc79f467-0f17-4e29-ad2f-fcec742d8aea.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1792708705/14de269c-0cc1-4355-8fd1-4b5655addeeb.png",
    },
    heroVideo: {
      type: "video",
      src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1792708380/pact_hero_clip.mov",
    },
    meta: {
      role: "Designer",
      collaborators: "Helen Luo, Cameron Zhang",
      duration: "Oct 2026",
      tools: "Cursor, React, Canva, Figma",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Participated in designing the relationship-building app Pact for SVSD Designathon 2026. Owned the Maps side of the project, using OpenStreetMaps data and custom shaders to create a tilt-shift effect.",
      },
    ],
  },
  {
    slug: "penn-electric-racing",
    title: "Penn Electric Racing",
    category: "Design / 3D",
    description: "Design and operations for formula racing team",
    links: [
      { url: "https://www.pennelectricracing.com/" },
      { url: "https://www.youtube.com/watch?v=Tpl9AfQJKxo", label: "Watch Unveiling Video" },
    ],
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790653122/DSC04492_aoifds.jpg",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790653115/20260620-DSC05127-2_epkwvg.jpg",
    },
    meta: {
      role: "Media / Business Operations / Project Manager",
      collaborators: "Operations Team",
      duration: "2025 – Present",
      tools: "Solidworks, Vercel, Blender, Maya, Adobe Suite, Procreate, Notion",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Penn Electric Racing (REV11) needs visuals that work for sponsors, social media, and internal morale. My role is to be in charge of creating the livery, the car renders, the sponsor-facing posters and presentation assets, and the tooling that keeps the business team aligned with engineering milestones. Although the team already has a strong visual language, I believe my job is to keep that language moving forward as the car itself changes.",
      },
      {
        type: "text",
        title: "Livery exploration",
        body: "Livery directions are prototyped in Solidworks and Blender texture painting so the team can compare scale, contrast, and sponsor lockups before paint shop commitments. Although a decal is cheap to change on a screen, it is expensive to get wrong on the car.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790653122/DSC04492_aoifds.jpg",
        caption: "Finalized livery design. Image credit: Arjun Sharma",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768443546/livery_designs_fkypyc.png",
            caption: "Early livery roughs board",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1772938899/Screenshot_2026-02-08_at_8.45.57_PM_rs34rx.png",
            caption: "Livery iteration A. These 3D mockups are done with texture painting in Blender, with retopologized cad models and low-poly versions of the car modeled by myself.",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1772938899/Screenshot_2026-02-08_at_8.47.32_PM_gpil4p.png",
            caption: "Livery iteration B",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1773291414/Screenshot_2026-03-11_225932_enfvvu.png",
            caption: "Solidworks livery prototype. The livery is later projected onto a surface and cut out using Silhouette Studio and a Silhouette cutting machine along with sponsor stickers, with some areas being spray painted on.",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1793139735/IMG_8277_1.heic",
            caption: "Final livery, with Rocky Balboa decal on the rear wing",
          },
        ],
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1772842240/rev_11_logo_test_v4_el956p.mp4",
        caption: "REV11 logo animation — done in Rive",
      },
      { type: "text", title: "Presentation Design and Graphics" },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768443294/cover_design_2_dt5pgo.png",
            caption: "Business presentation cover, made using Photoshop and Maya",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790649636/Penn_Electric_Racing_070_-_2026_Excellence_in_Technical_Innovation_Award_Submission-3_uinwhv.png",
            caption: "Finalized slides. The presentation won 1st place in the Excellence in Technical Innovation category, earning ~$8,000 in prize money for free registration for the team.",
          },
        ],
      },
      {
        type: "callout",
        icon: "lightbulb",
        title: "Working with the system",
        body: "Penn Electric Racing already has an established design language, which is evident in the maintenance of their website, social media, club colors, and fonts. As a designer I try to create material that both emulates and expands on the visual style of the team, rather than replacing it with a look that would only last one season.",
      },
      {
        type: "text",
        title: "Rendering 3D Models",
        body: "PER can benefit from more sophisticated 3D models that serve as visuals for its social media and merch. I followed my own guidelines in creating a scalable and efficient pipeline to treat the thousands of parts on the car through different versions, because I did not want every new render to start from a raw CAD dump again.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790648865/anduril_v4_mdfsnf.png",
        caption: "A 3D model using the materials system I developed, used in our 2026-2027 sponsorship package. The layout is inspired by a graphic for the Anduril Fury.",
      },
      { type: "text", title: "Use Cases" },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "presentation",
            title: "Presentation visual aid",
            body: "The models have to match our business presentation's need of labeling individual parts without much visual clutter, so a sponsor can read a system at a glance.",
          },
          {
            icon: "shirt",
            title: "Merch and Media",
            body: "The models also have to be flexible enough to be incorporated into our sponsorship package, merch, unveiling, and social media posts. I believe that flexibility is what makes a pipeline worth the time it takes to build.",
          },
        ],
      },
      {
        type: "text",
        title: "A Messy Manual Pipeline",
        body: "As I was making visuals for models, I started off with a raw import without any modifications from Solidworks to Maya, and I immediately ran into performance issues. Seeing no apparent alternatives, I manually adjusted parameters in all of the 3D apps I imported the CAD to, with much chagrin. Although that work got images out the door, I knew it could not be the system we lived with.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790819098/REV11_fully_textured.jpg",
      },
      {
        type: "callout",
        icon: "frown",
        title: "Solidworks Visualize",
        body: "Although the materials transition was the easiest, the renderer struggled massively with the file size, taking ten hours to render a video filled with graphical glitches due to an unoptimized model. I realized I needed to retopologize or delete some parts manually to keep the poly count low, or we would keep paying that wait on every revision.",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1790819508/translucent_test_vid_1.mp4",
      },
      {
        type: "callout",
        icon: "frown",
        title: "Maya",
        body: "Maya was a better alternative, but it struggled with the massive amount of duplicate objects merged into each other and thousands of unwanted materials — opening Hypershade would crash my computer. Even so, I was able to utilize the nCloth feature to render a few test scenes for the car unveiling, which is what convinced me the pipeline was worth continuing.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790819710/Screenshot_2026-03-27_at_1.23.22_AM.png",
      },
      {
        type: "callout",
        icon: "smile",
        title: "Blender",
        body: "I completed my retopology in Blender and added modifiers to different parts to create wireframe animations. Using shader graphs, I created most of the animated shaders shown in the presentations and videos below, and I believe that is where the car finally started to look like it belonged in our decks.",
      },
      {
        type: "text",
        title: "Next Steps",
        body: "The current system is time consuming and stressful to operate. With the appearance of new technology that connects CAD with other types of rendering and simulation software, I am currently working on modular, efficient software that allows different parts of the team to access certain parts of a vehicle's information without overriding anything. Although that tool is still in progress, I believe it is the only way this pipeline becomes something the whole team can use.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790822506/3c1531cc-9fc5-4e37-8579-1ab4e699ad3c.png",
        caption: "The proposed software stack. Currently building using Cursor and GrokBot.",
      },
      {
        type: "callout",
        icon: "notebook-pen",
        title: "Final Thoughts",
        body: "In a new era of photorealistic graphics, as a cutting-edge competition racing team, I feel like I've taken us a step forward. In the coming year, I will work closely with the vehicle dynamics team and the driverless team to improve my system. Although the technological hurdle is significant, I believe that with the time saved transferring between different file systems and the potential of agents to automate the maintenance of vehicle systems as a whole, this can be more than a fancy pipeline for 3D renderings. It can be a way to speed up all kinds of testing and design work.",
      },
      {
        type: "text",
        title: "Posters & business media",
        body: "Poster and cover art support recruitment and sponsor meetings. They often start in 3D and finish in Photoshop or Procreate, where I can hand-tune the typography once the car is already sitting in the frame.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790648869/design-1778317614466_qvzjvu.png",
            caption: "Competition uniforms design",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442451/PER_car_drifting_better_v2_ps_cvjatn.png",
            caption: "Poster — Photoshop and Gemini assist",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442913/IMG_2018_2_guzdye.png",
            caption: "Render-to-poster workflow — Maya and Procreate",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442913/Rev_11_comic_better_lettering_t3y9nt.png",
            caption: "Rally-style poster variant",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442716/Untitled_Artwork_1_bs0bnx.png",
            caption: "Concept sketch — composition study",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442715/Untitled_-_December_11_2025_01.13.36_ybcmhj.jpg",
            caption: "Poster rough sketches",
          },
        ],
      },
      {
        type: "text",
        title: "GM Presentation",
        body: "I created a presentation that utilized limited space and optimized the design and clarity of the content, because a projector will not forgive a crowded slide.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790651510/e30507f3-6321-4ca8-9b2c-4bcd1068d2eb.png",
        caption: "Process breakdown",
      },
      {
        type: "text",
        title: "Business Presentation",
        body: "I created stylized renders to visually demonstrate the presentation topics, so the business team could talk about systems without pointing at a raw CAD screenshot.",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1779599483/0000-0630_PER_biz_prez_ctejsr.mov",
        caption: "Video breaking down different part categories",
      },
      {
        type: "text",
        title: "Car visualization",
        body: "Full-car renders combine Solidworks CAD, Visualize, and Maya for lighting passes used in decks and Instagram. I treat those images as the public face of the car long before the physical bodywork is finished.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442453/per_good_render_2_lnzuf6.jpg",
            caption: "Studio render — three-quarter front",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442452/per_good_render_3_ptceqx.jpg",
            caption: "Studio render — side elevation",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442452/per_good_render_5_ml3xcb.jpg",
            caption: "Solidworks → Visualize → Maya pipeline",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768442452/per_good_render_6_phw7ny.jpg",
            caption: "Detail render — aero and sponsor panels",
          },
        ],
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790652314/000383660022_l9sne0.jpg",
        caption: "Penn Electric Racing was one of the most stressful, challenging and exhilarating experiences of my freshman year. I learned so much and I'll do it again without hesitation, but I will also keep the life lessons in my heart.",
      },
    ],
  },
  {
    slug: "provelis",
    title: "Provelis",
    category: "UI / Product",
    description: "Complete UI overhaul and frontend–backend integration for a recruiting platform",
    thumbnail: {
      type: "video",
      //src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790642179/d7790251-8429-4deb-af56-9ff3ca85aa63.png",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1784453857/Screen_Recording_2026-07-19_at_5.35.46_AM_exov4y.mov",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790647084/ddf97bda-00dd-4f01-9c0b-430bd12d2585.png",
    },
    meta: {
      role: "UI contractor",
      collaborators: "Axiom / Caliber team",
      duration: "Jun – Jul 2026",
      tools: "Figma, React, TypeScript, Cursor",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Provelis is a talent-intelligence console for time-boxed staffing on large IT deals. Deal data comes in — what needs to be done, by whom, and where — and a recruiting supervisor tracks which job requirements are actually filling. I was hired on a short contract to overhaul a vibe-coded UI so it could hold up for enterprise users, and to wire the new screens to live backend services before a July go-live. Although the window was only two months, I believe the work was less about making the console look finished and more about making it something a supervisor could trust under load.",
      },
      { type: "text", title: "Final product" },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453341/Screenshot_2026-07-12_at_4.50.19_AM_vuuepl.png",
            caption: "Home — open jobs, stalls, and funnel health on one grid, each panel expandable to a full list",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453341/Screenshot_2026-07-12_at_4.50.28_AM_lbrjo0.png",
            caption: "Requirements — jobs table with pipeline and conversion, reused from the existing table language instead of a new chrome",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453341/Screenshot_2026-07-12_at_4.50.11_AM_mcitvj.png",
            caption: "Interview overview — score cards, AI verdict, strengths / weaknesses",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453340/Screenshot_2026-07-12_at_4.50.53_AM_ujaa7y.png",
            caption: "Recruiters — performance table and throughput widgets",
          },
        ],
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790910369/Untitled_Artwork_78.png",
        caption: "How Provelis sits in the hiring loop. Candidates come in from job boards and people looking for work. Provelis runs interview flows out to recruiters, takes their manual reviews back in, and stays connected to Axiom so the console can handle a large, time-boxed search without the team leaving the tool.",
      },
      {
        type: "text",
        title: "The brief",
        body: "The first assignment was one home screen. Most of the pipeline was already automated from requirement to shortlist, so what still needed a person was candidates answering interviews and recruiters reviewing the top ones. The page had to show, in order, where that pipeline was stalling, which jobs were open and what their status was, the AI interview scorecards, and who needed a decision — with a prompt button, not just a number. Although the look had to stay corporate and data-dense, I believed it still had to be readable on a normal laptop, not only on a trading-floor monitor.",
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "target",
            title: "Shorter paths",
            body: "Leadership and the backend lead wanted the distance between buttons and functions as short as possible, so a supervisor could act without hunting through extra pages.",
          },
          {
            icon: "layers",
            title: "Higher density",
            body: "The same brief asked for more information on a single screen. I took that to mean density had to serve a decision, not merely fill the canvas.",
          },
        ],
      },
      {
        type: "text",
        title: "Cleaning up v1",
        body: "The first version had been coded with almost no design direction. It was full of duplicate screens, messy connections, and type and functions that did not need to be there. I stripped those out, then rebuilt the pages around modular windows and dense lists, taking cues from the S&P terminals investment bankers use — a format that already matched how Provelis stored its data. The first sample used scalable windows, a collapsible sidebar, and outlined clickable controls. I tried tiles for the important action items, then switched to a list because a list was easier to scan. Although that pass did shrink the distance between pages, I would later learn that a denser terminal is not the same thing as a clearer one.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790908804/Untitled_Artwork_77.png",
      },
      {
        type: "callout",
        icon: "building-2",
        title: "Initial brainstorming",
        body: "Modular windows and long lists felt like the right language for a professional ops tool, so I treated that as the design system for the first rebuild. After review I cut a large KPI strip of redundant numbers and a one-item notification banner that ate a full row for a single alert, because those pieces looked finished without actually helping anyone decide.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790962707/bf25457f-d74a-4ecd-8cb3-0a3a1fd9efad.png",
        caption: "Comparison between UI choices of S&P Capital and Provelis' dashboard. Note the information and page density of S&P as well as the necessarily larger monitor that the software must run on, which wasn't available to Provelis' users. This poor scaling and readability is one reason why this design didn't work!",
      },
      {
        type: "text",
        title: "Initial feedback - it was confusing",
        body: "Hiring managers — the people Provelis is actually for — said the rebuild was hard to use. The hiring tool they already used felt more intuitive and less cluttered, and it let them customize tables. I had to throw out the first system and start from their working habits instead of from a denser terminal, even though that first pass had already taken a large share of the contract.",
      },
      {
        type: "callout",
        icon: "frown",
        title: "Talk to the users earlier",
        body: "I designed against an internal brief instead of checking each feature idea with hiring managers, which is why the first version looked finished and still failed. Later click-throughs kept finding the same class of problem: table headers that did not stick, filters that did not filter, buttons that went nowhere, a search box that ate keystrokes, and a job description that was too small on the requirement canvas. I believe those issues are what smoke tests would have caught if I had run them earlier.",
      },
      {
        type: "text",
        title: "A clearer console",
        body: "I dropped the top sliding bar of buttons for a side panel that opens and closes, reused the existing table assets instead of inventing new ones, and used icons plus changes in padding and type to mark what mattered. After the concepts landed, the home grid they asked for was client rows, stalls, recruiter output, and a schedule — each panel expandable to a full list. Urgency was the item that had sat longest, or the one closest to an SLA. The goal was the same density, but with a layout hiring managers already recognized, and I think that recognition is what finally made the console usable.",
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "panel-left",
            title: "Collapsible side nav",
            body: "Primary actions live in a panel that can get out of the way, instead of a sliding top bar that competed with the data for attention.",
          },
          {
            icon: "table",
            title: "Reuse before invent",
            body: "Tables, icons, and type scale do the hierarchy work. New UI chrome is expensive, and in this case a visual rewrite was enough to take the prototype backend down.",
          },
        ],
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "app-window",
            title: "One canvas, not a stack of popups",
            body: "Clicking a job opens the description, candidates, and actions on one screen, with a breadcrumb back path — dashboard, then job, then candidate. Stalls and interviews get hover peeks instead of another hidden menu, so a recruiter can stay on the canvas while they move through a large pile.",
          },
          {
            icon: "swatch-book",
            title: "Parchment over glass",
            body: "Rounded Liquid Glass and frost looked pretty and read as unprofessional. Stakeholders picked the sharp, parchment, high-density direction: blue and white to match the logo, with no purple, no generic AI glyphs, and no extra titles sitting on top of the data.",
          },
        ],
      },
      {
        type: "text",
        body: "The first job screen put the description, the rubric, and the invite tools on one surface, so nothing told a recruiter where to go next. The revision clears that pile into open space. Navigation sits in a column on the left, the review runs downward through the recording and the transcript, and Advance, Hold, and Reject stay in view beside that scroll, so the way through the page is marked.",
      },
      {
        type: "compare",
        before: "https://res.cloudinary.com/dak0zi45d/image/upload/v1791262642/provelis/provelis-tear-v1.jpg",
        after: "https://res.cloudinary.com/dak0zi45d/image/upload/v1791262643/provelis/provelis-tear-v2.jpg",
        beforeCaption: "Before. The job, the score, and the next action all compete for the same screen.",
        afterCaption: "After. Open space, a column to navigate, and a review you read downward.",
      },
      {
        type: "text",
        title: "Redefining User Flow",
        body: "I redesigned roughly 40 screens across the console. The executive portal was the core, and a recruiter-scoped twin followed — only assigned jobs, with louder review and advance actions. I also started a lighter pass on the candidate interview screens, although I did not land a finished candidate portal. Two surfaces mattered most while the rest of the system came together.",
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "columns-2",
            title: "Resume beside the job",
            body: "A side-by-side view so hiring managers can read a resume against the job requirements without flipping between pages, which was one of the shortest paths the brief had asked for.",
          },
          {
            icon: "list",
            title: "Modular hire list",
            body: "A list of hires that can be rearranged and scanned the way they already work through a pipeline, instead of inventing a new chrome they would have to relearn.",
          },
        ],
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790920216/3ea4d7c8-cf28-47e8-a087-196eef7f1cb6.png",
        caption: "Important details are never more than three links away. Pop-ups and half-pages sit on top of the main canvas so recruiters can move through large applicant piles without leaving the job. Many links between pages are not shown.",
      },
      {
        type: "text",
        title: "Home & pipeline",
        body: "The home dashboard surfaces open requirements, submissions, interview volume, and funnel health so a supervisor can see which jobs are filling without opening five tabs. I wanted that grid to be the place a day starts, not a pretty empty circle that still required another page.",
      },
      {
        type: "text",
        title: "Recruiters & analytics",
        body: "Recruiter performance and live analytics pull from completed interviews so ops can track verdicts, weekly throughput, and submit rates in one place. Although the numbers were already in the backend, they were not useful until they sat next to the people who had to act on them.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453340/Screenshot_2026-07-12_at_4.51.10_AM_btd9ws.png",
        caption: "Analytics — verdict distribution and weekly completions",
      },
      {
        type: "text",
        title: "Workflow builder",
        body: "Interview workflows are editable node graphs, from simple round sequences to multi-step outreach, wait, and verification flows with live save state and AI-assisted resets. I kept an earlier, more elaborate graph because it showed why we scrapped it: the feature set was incomplete, and the graphics could not be trusted.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453341/Screenshot_2026-07-12_at_4.51.31_AM_rwb6s2.png",
        caption: "Workflows list — active journeys and running counts",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453340/Screenshot_2026-07-13_at_10.58.43_AM_xvcquv.png",
            caption: "Interview rounds — linear workflow canvas",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453340/Screenshot_2026-07-12_at_4.52.39_AM_b62ijs.png",
            caption: "Previous design for a workflow graph, scrapped due to graphical glitches and incomplete feature set",
          },
        ],
      },
      {
        type: "text",
        title: "Interview review",
        body: "Candidate review combines recording, transcript, AI verdict, strengths and weaknesses, and proctoring signals so recruiters can advance, hold, or reject from one screen. I believed that decision had to stay on the same canvas as the evidence, or the shorter path the brief asked for would collapse back into tab-hopping.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453339/Screenshot_2026-07-13_at_11.02.48_AM_irbgsg.png",
            caption: "Evaluation — webcam + transcript beside decision panel",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453339/Screenshot_2026-07-13_at_11.02.57_AM_fs7hct.png",
            caption: "Verify — cheating likelihood and proctoring signals",
          },
        ],
      },
      {
        type: "text",
        title: "Sourcing & ops",
        body: "Deep Search and Problems close the loop: external-only candidate sourcing with verification, plus a severity queue for stalled requirements. I ordered that queue by the longest wait and the closest SLA, because a pretty empty circle would not have told a supervisor where to put the next hour.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453339/Screenshot_2026-07-13_at_11.04.19_AM_p9xuqq.png",
            caption: "Deep Search — JD parse and external source config",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1784453339/Screenshot_2026-07-13_at_11.04.14_AM_c9fsbd.png",
            caption: "Problems — stalled requirements ordered by longest wait and closest SLA, not a pretty empty circle",
          },
        ],
      },
      {
        type: "callout",
        icon: "shield",
        title: "No separate test backend",
        body: "I could not fork production for security and clearance reasons, and I also could not run the full stack locally. Previews went through a shared cluster with 10–20 minute deploys, so a style change and a wiring bug looked the same until they landed. Interview video and resumes lived on a service with no safe development copy, which is why some paths stayed empty on the preview and why a visual rewrite could take the backend down. My lead unblocked cluster access, and I owned the UI wiring. Although that constraint was frustrating, I believe it is also why click-through QA had to be part of the design rather than a pass after ship.",
      },
      {
        type: "callout",
        icon: "notebook-pen",
        title: "What I learned",
        body: "I will reuse what already works, talk to the people who run the desks — not only the internal brief — and be careful prompting agents so a visual rewrite cannot take the backend down. I will also treat click-through QA as part of the design. One of my biggest regrets was wasting time designing an entire UI using a misguided philosophy. I should have conducted smoke tests way before I was finished, so I would have known what direction I should be headed in. With little guidance from my lead, I took this project as a learning experience to help me on my future endeavors in UI design.",
      },
      { type: "text", title: "Video demo" },
      {
        type: "video",
        src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1784453476/Screen_Recording_2026-07-19_at_5.29.23_AM_gd3tts.mov",
      },
    ],
  },
  {
    slug: "clockwork-climb",
    title: "Clockwork Climb",
    category: "Game / 3D",
    description: "Producer-led three-week physics puzzle game for a team of five",
    links: [
      { url: "https://team-xiv.itch.io/clockwork-climb", label: "Play Game" },
    ],
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791076698/xVWkB7.png",
    },
    hero: {
      type: "youtube",
      src: "ZJojZok5p28",
    },
    meta: {
      role: "Producer / Artist",
      collaborators: "Ryan Nguyen, Thomas Zhao, Kelin Levine, Andrew Koes",
      duration: "Jun – Aug 2024",
      tools: "Unity, Maya, Blender, Substance Painter, FL Studio, Jira",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "In Clockwork Climb, you cannot steer the cuckoo birds. You draw bounce-belts they ricochet off of, and you have to get the flock to the clock tower. I led a team of five through a three-week production, first as producer and project manager, with executive say on the design decisions that kept the slice shippable. Although my time on any one screen was limited, I also owned the background assets, the lighting, and most of the in-engine placement, so the levels could look like a game while the systems were still landing.",
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "target",
            title: "Why this pitch",
            body: "We took three ideas to the judges, and this one was preferred because of its scale and because nobody else was asking the player to draw the path instead of driving the character. I believe that uniqueness is what made the mechanic worth building in three weeks.",
          },
          {
            icon: "users",
            title: "Five people, three weeks",
            body: "Although my design time on any one screen was limited, I treated the board as the real design surface. I kept the team updated through Kanban, Google Sheets, and Jira, and I used that visibility to make the calls that kept the slice shippable.",
          },
        ],
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790966347/Pitch_Round2_Team14.png",
        caption: "Early ideation slides — three pitches; this one won on scale and a control scheme nobody else was doing",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790966348/1Q8HtshOk5zNy3jDlab08Fug1BrQqrsQpxabGxKPTfKI.jpg",
        caption: "Concept art for a steampunk feel",
      },
      {
        type: "text",
        title: "Paper, then a working bounce",
        body: "The pitch started on paper so the mechanic would be readable before anyone opened Unity. Our programmers turned that drawing into a playable level with working trampolines, and that demo is what proved we were making a game rather than a picture of one.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790966150/1l4i4LIQVV-Mj35tYcxD-LbW6BRTYiHdRg4RT7r6fk3M.gif",
        caption: "Early prototype — a playable bounce before the art pass",
      },
      { type: "text", title: "Prototyping the trampoline" },
      {
        type: "gallery",
        columns: 2,
        items: [
          {
            type: "video",
            src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1790977878/Screen_Recording_2024-07-20_at_12.06.00_AM.mov",
            caption: "Complex trampoline — the bounce worked, but the object cluttered every puzzle",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1790977241/Screenshot_2024-07-23_at_8.49.53_PM.png",
            caption: "Final, simpler trampoline — same mechanic, less visual noise",
          },
        ],
      },
      {
        type: "text",
        title: "Weeks one and two",
        body: "While the artists built the models, sound designed the feel of a bounce, including slow-motion treatments and 3D spatial audio so a landing could be heard as well as seen. I was responsible for most of the background assets, the lighting, and the environmental optics we discovered we could afford once the first scenes were in. I also placed most of those assets in the engine, because I did not want the levels to sit as gray boxes waiting on a final art pass.",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1790977405/Screen_Recording_2024-07-20_at_7.24.15_PM.mov",
        caption: "Transition between 2D and 3D assets",
      },
      {
        type: "text",
        title: "Weeks two and three",
        body: "In the second and third weeks we added more models, more obstacles, and the camera, tutorial signaling, and UI that teach the first levels without a wall of text. The customizable level editor, which used custom game objects for trampolines and the rest of the kit, is what let us iterate puzzles without waiting on a programmer for every bounce.",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/fet3ks1c/video/upload/v1790977511/Screen_Recording_2024-08-01_at_1.46.19_PM.mov",
        caption: "Cannon particle effects",
      },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "pencil-ruler",
            title: "Level editor",
            body: "Although we only had three weeks, the level editor meant designers could drop trampolines, belts, and obstacles and tune a puzzle without a code change. I believe that is how a small team ships more than one good level.",
          },
          {
            icon: "volume-2",
            title: "Audio as feedback",
            body: "Slow-motion and spatial audio were not garnish. They told you a bounce had landed when the camera was already moving, and I think that feedback is a large part of why the mechanic felt readable on a phone.",
          },
        ],
      },
      {
        type: "text",
        title: "Building for a Mobile Game",
        body: "The trampoline aspect of the game is meant for a mobile-first experience, so we considered everything from both PC and mobile standpoints. Custom gestures can only happen one at a time, which is why we spaced the UI so that a swipe cannot touch any of the buttons. We also considered a lot of edge cases, including trampolines drawn at the edge of the screen and bird collisions. In the end, we playtested with a lot of students and faculty and used their feedback to improve the responsiveness of our trampolines and camera gestures, as well as the intuitiveness of the UI, given our time constraints.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791143117/Screenshot_2026-10-04_at_3.44.42_PM.png",
        caption: "One of our student mentors, Airan, testing our game.",
      },
      {
        type: "text",
        title: "The hard part",
        body: "The most challenging part of the project was making sure everything was done on time. Because of the scope of our levels, we spent a lot of sleepless nights coding and debugging. In hindsight there was not that much backtracking, although there was a great deal of work. I believe we scoped the project to what this team could actually finish, and that is the producer work I care about: fewer heroic recoveries because the plan already fit the people.",
      },
      {
        type: "callout",
        icon: "notebook-pen",
        title: "What I learned",
        body: "A paper prototype and a trampoline demo beat a prettier pitch, and I will keep the team on one board next time. I also learned to own the unglamorous art — backgrounds, lighting, and placement — so the levels look like a game while systems are still landing. Although the clock was tight, I believe the lesson is to scope to the team's actual capacity, and then protect that scope.",
      },
    ],
  }, /*
  {
    slug: "alex-twin",
    title: "AlexTwin",
    category: "WebGL / 3D",
    description: "Web-based, 3D world simulation for distribution",
    visitUrl: "https://alex-twin.com/",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780348329/Screenshot_2026-05-31_at_1.56.03_AM_i2cikb.png",
    },
    hero: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1780539409/Screen_Recording_2026-06-03_at_7.15.23_PM_mleipg.mov",
    },
    meta: {
      role: "Solo Developer",
      roleDescription: "Everything!",
      collaborators: "",
      duration: "2026",
      tools: "Cursor, React, Cesium, Google 3D Tiles, Playwright MCP",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "AlexTwin is a web-based 3D world simulation built for distribution and live demo. The goal was to make a dense AR + assistant stack feel legible on a phone in a single hackathon sprint.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780538718/IMG_2071_peicap.jpg",
        caption: "UI and app structure brainstorming",
      },
      {
        type: "text",
        title: "Interface & build",
        body: "",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780348329/Screenshot_2026-05-31_at_1.53.46_AM_jwljs2.png",
            caption: "Light mode - less performance-heavy, from 1.2 GB to 200 MB",
          },
        ],
      },
    ],
  }, */
  {
    slug: "orble-tea",
    title: "Orble Tea",
    category: "Brand / Business",
    description: "Comprehensive branding and business work",
    visitUrl: "https://orble-tea.com/",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1793139243/IMG_7753.heic",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768444772/Screenshot_2026-01-14_at_9.39.22_PM_qrxnda.png",
    },
    meta: {
      role: "Brand Designer / Developer",
      collaborators: "Orble Tea Team",
      duration: "2025 – Present",
      tools: "Astro, Blender, Maya, Onshape, React",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Orble Tea is an automated boba concept spanning product design, brand, and go-to-market visuals. I shape Orble's visual identity, hardware storytelling, and marketing site, tying physical machine design to a coherent digital presence on orble-tea.com — from CAD-backed renders to vinyl wraps and architectural viz for investor decks.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768444772/Screenshot_2026-01-14_at_9.39.22_PM_qrxnda.png",
        caption: "Marketing site and brand snapshot",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1772842030/IMG_5522_2_1_gfa0m8.png",
        caption: "Vinyl wrap for the 'coming soon' launch box",
      },
      {
        type: "text",
        title: "Hardware & beta unit",
        body: "Beta vending concepts combine Onshape CAD, Substance texturing, and Blender lighting so stakeholders can read materials and footprint before fabrication.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1773974232/Untitled_Artwork_64_yrjse5.png",
            caption: "Beta vending machine — industrial design pass",
          },
          {
            type: "image",
            src: "https://orble-tea.com/.netlify/images?url=_astro%2Ffront-left.D0kYN4sG.jpg&w=1280&h=1280&dpl=69483ebca7d51e0008be244d",
            caption: "Beta unit render — card reader and boba materials",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768445467/textured_reexport_v2_pattern_BaseColor_qdm7px.png",
            caption: "Substance Painter surface maps",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768446936/orble_next_gen_render_1_720_zykg6e.png",
            caption: "Next-gen machine — Onshape CAD with custom materials",
          },
        ],
      },
      {
        type: "text",
        title: "Architectural visualization",
        body: "Location renders (airport, apartment, campus) place the machine in real contexts for pitch decks and partner conversations.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768444581/airport_render_3_wmsjre.jpg",
            caption: "Airport / station placement study",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768444580/airport_render_png_sr8ls4.jpg",
            caption: "Station visualization — final lighting",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768554175/Screenshot_2026-01-16_at_4.02.36_AM_cgw82a.png",
            caption: "Wireframe overlay for layout review",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768446826/archviz_apartment_1_vaftas.jpg",
            caption: "Apartment lobby context",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768554330/archviz_1_with_people_studying_1_lkmnqf.jpg",
            caption: "Academic building — foot traffic study",
          },
        ],
      },
    ],
  },
  {
    slug: "saturn",
    title: "Saturn",
    category: "Long term indie project",
    visitUrl: "https://al371160.itch.io/saturn",
    thumbnail: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1790636205/Screen_Recording_2025-08-05_at_8.05.04_AM_w94srq.mov",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1790636355/Screenshot_2026-05-08_at_11.10.00_PM_mxxr1n.png",
    },
    meta: {
      role: "Solo Developer",
      collaborators: "Solo Developer",
      duration: "Sep 2025 - Present",
      tools: "Adobe Substance 3D, Blender, Maya, Procreate, Unity, Cursor",
    },
    content: [
      {
        type: "callout",
        icon: "hammer",
        title: "In development",
        body: "Saturn is a long-term indie project I am building in public. Although the systems are still moving, I believe the latest build on itch.io is the honest way to follow the work, rather than waiting for a finished trailer.",
      },
      { type: "text", title: "Part 1: Initial Ideation" },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791062989/05c8860d-e4ae-4b0e-a8ee-1fbe382ed3fd.png",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791063307/eaeed77a-af2b-4b83-95c9-bad23d7f4fb4.png",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791063310/Life_Project___SATURN_DEVLOG_1.png",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791065080/e41c0717-ca2c-40e4-98f7-6859082db343.png",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791065411/Screenshot_2026-10-03_at_6.05.08_PM.png",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791065857/95c3dfe3-1992-4403-a049-463537f7a1a4.png",
          },
        ],
      },
      {
        type: "gallery",
        columns: 2,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067721/80febfd5-86e5-4d22-9ff0-0eeafaa1effa.png",
            caption: "Player character — first look",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067797/856c492e-d188-4ce3-9830-70a72fb2ec2f.png",
            caption: "Player character — second look",
          },
        ],
      },
      {
        type: "text",
        title: "Shader graphs",
        body: "I built the look in Unity's Shader Graph, and it settled into two main types: outline and toon. Although the first direction had been more photoreal, I believe these shaders are what made the stylized characters read as a world instead of as unshaded meshes.",
      },
      {
        type: "gallery",
        columns: 2,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067852/9b6f0d31-e023-45b0-9d94-47e2c1a7576f.png",
            caption: "Outline shader",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067878/fa1fc64c-2745-4b81-bc9e-9504ec516f49.png",
            caption: "Toon shader",
          },
        ],
      },
      {
        type: "text",
        title: "Reddit feedback",
        body: "I posted the first look on Reddit. The comments were more useful than the upvotes, because they pointed at what was actually reading and what felt unfinished. There was not enough audience interest in the direction as-is, which is why I stopped chasing a more realistic look and went stylized instead. I believe that lack of interest was the most useful note I received.",
      },
      {
        type: "gallery",
        columns: 2,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067542/678c003a-3c89-4589-8c0d-d317434c589c.png",
            caption: "The Reddit post",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791067659/f185f8c0-fea1-4883-9cac-9929209d67af.png",
            caption: "Thread replies — what to improve, and how little the first look landed",
          },
        ],
      },
      {
        type: "text",
        title: "Part 2: Building Environment System",
        body: "I have been figuring out an optimized gameplay loop that allows for a balance between story elements and the freedom of an open-world-style game. Although that balance is still in progress, more of the build process is in the playlist below, and I will keep posting as the loop gets tighter.",
      },
      {
        type: "youtube",
        caption: "Devlog playlist — more on building the environment system",
        videos: [
          { id: "1ZKG80DDljo", title: "1. A sci-fi game with cute characters" },
          { id: "XbzYm5wNigI", title: "2. Particles" },
          { id: "pDKNjWU0IOo", title: "3. A shovel" },
          { id: "a1dzSb7StEY", title: "4. Sneak peek" },
          { id: "verelvJnAJw", title: "5. Sneak peek" },
          { id: "NpH4H6Ed2f8", title: "6. UI and sounds" },
          { id: "qQqLht83Yc0", title: "7. Satisfying particles" },
          { id: "RTczT0sMYUE", title: "8. Prototype minigame" },
          { id: "TQKmx1rhYF4", title: "9. Better items" },
          { id: "JYhZhSb9nVQ", title: "10. Multiply 10x" },
          { id: "InTSJgn9ZNU", title: "11. AI navigation" },
          { id: "AGbfwFoJGZU", title: "12. Chopping wood" },
        ],
      },
      { type: "text", title: "Technology Highlights" },
      {
        type: "callout",
        columns: 2,
        items: [
          {
            icon: "camera",
            title: "Camera system",
            body: "Cameras are driven by a Cinemachine controller. As the player enters and exits certain colliders, scripts on those colliders store distance, angle, and orientation — including what the camera should look at — and interpolate between positions. The result is a dynamic fixed-camera style closer to A Short Hike than a free orbit, and I believe that constraint is what makes a location feel authored.",
          },
          {
            icon: "messages-square",
            title: "NPC system",
            body: "A custom dialogue system covers multiple NPCs: physical movement, quests, world-space speech bubbles with player choices, branching dialogue — including cycles when a quest locks a path — and swapping models. Dialogue is the hard part, because I still have to handwrite it at any length. In the coming months I will need interactions between different NPCs, not only player-to-NPC, if the world is going to feel inhabited rather than queued.",
          },
        ],
      },
      {
        type: "text",
        title: "Part 3: Next Steps",
        body: "In the coming months I will try to make traversal between locations more engaging. Although the loop is starting to hold, I believe the walk from one place to another is still doing too little of the storytelling.",
      },
      {
        type: "text",
        title: "Current Gameplay Loop",
        body: "I organized a gameplay doc to pin down the loop — what the player does, what comes back, and where story beats sit against open-world freedom — before I keep adding systems. Although it is still a working document, I believe writing the loop down is what will keep the next features from drifting.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/fet3ks1c/image/upload/v1791069707/4f823804-9f74-4263-8f55-09c8b2db2ce5.png",
        caption: "Gameplay loop graph from the design doc",
      },
    ],
  },
  /* {
    slug: "ragebaiter",
    title: "Ragebaiter",
    category: "Product / Experiment",
    description: "Gamifying the approach to online discussion of sensitive topics",
    visitUrl: "https://ragebaiter-three.vercel.app/",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780358115/Screenshot_2026-06-01_at_4.54.37_PM_wceqgw.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780553617/copy_of_screenshot_2026-06-03_at_110949_pm_nsbvux.png",
    },
    meta: {
      role: "Solo Developer",
      roleDescription: "Designed and built the full stack solo — product concept, UI, and inference pipeline — to test whether game mechanics could make heated threads more constructive.",
      collaborators: "Solo",
      duration: "2026",
      tools: "Cursor, React, Python",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Coming soon!",
      },
    ],
  }, */
  {
    slug: "aquara",
    title: "Aquara",
    category: "UI / Brand",
    description: "Direct, modular UI for professional clients",
    visitUrl: "https://aquara.ai",
    thumbnail: {
      type: "photo",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780352903/Screenshot_2026-06-01_at_3.28.05_PM_qx6qst.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1781073756/Screenshot_2026-06-09_at_11.41.06_PM_acnflh.png",
    },
    heroVideo: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1784514310/Screen_Recording_2026-07-19_at_10.15.40_PM_ajusoi.mov",
    },
    meta: {
      role: "UI Lead",
      collaborators: "Benjamin Liu, Ivan Zhang, Theo Weises",
      duration: "2026",
      tools: "Figma, React, TypeScript",
    },
    content: [
      {
        type: "photo",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1781073756/Screenshot_2026-06-09_at_11.41.06_PM_acnflh.png",
        caption: "Designs for LinkedIn banners.",
      },
      {
        type: "text",
        title: "Overview",
        body: "Aquara is a professional client portal built around clarity under load. Accountants and ops leads need numbers, status, and actions without hunting through nested menus. I led the interface architecture — modular panels, dense data tables, and a calm visual system that still feels fast at a glance — because I believe a portal that looks busy will be treated as busy work.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1780352903/Screenshot_2026-06-01_at_3.28.05_PM_qx6qst.png",
        caption: "Dashboard shell — modular cards and primary actions",
      },
      {
        type: "gallery",
        columns: 3,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1781073756/605565783-10a40fe6-62d1-4e2c-acde-876730388469_ffsfpv.png",
            caption: "Settings layout for the chrome extension sidepanel",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1781073756/605566129-7f5cc883-6063-4493-80d4-b67e5039c3b1_rzi9mp.png",
            caption: "Onboarding checklist",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1781073756/605566359-5cc8e0e4-7b30-4dc1-aecf-1e6b0c9c7b1b_slimdt.png",
            caption: "Onboarding tutorial",
          },
        ],
      },
      {
        type: "text",
        title: "Design principles",
        body: "Type scale and spacing follow an 8px grid. Components are swappable blocks — summary, ledger, alerts — so new client verticals can reuse the same frame instead of asking for a new product. Color is mostly neutral, with a single accent for CTAs and risk states, because I wanted urgency to be a rare signal rather than a default.",
      },
      {
        type: "text",
        title: "Next steps",
        body: "In the coming months I will continue to tighten the responsive breakpoints and the empty states for first-time client onboarding. Although the shell is in place, I believe those first-run screens are still where a professional product either earns trust or loses it.",
      },
    ],
  },
  {
    slug: "omni",
    title: "Omni",
    category: "Product / Tools",
    description: "Accessible, interactive toolmaking for users",
    visitUrl: "https://devpost.com/software/omni-hzxqra",
    thumbnail: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1769220262/IMG_5239_pwu4jw.mov",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1769220305/Untitled_Artwork_56_ppoklz.png",
    },
    meta: {
      role: "UI Lead",
      collaborators: "Benjamin Liu, Ivan Zhang, Theo Weises",
      duration: "2026",
      tools: "Rive, XCode, ARKit, Swift, Antigravity, Overshoot API",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Omni is an accessible AR assistant for interactive toolmaking: users describe what they need, see it in space, and refine it through voice and touch. I directed the UI, from layout and motion to Xcode implementation and demo-ready polish, keeping the interface calm while the backend orchestration stayed complex.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1769220305/Untitled_Artwork_56_ppoklz.png",
        caption: "Assistant character and UI sketch sheet",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1769220430/Screenshot_2026-01-23_at_9.07.00_PM_gbwxam.png",
        caption: "Logo and visual identity",
      },
      {
        type: "text",
        title: "iOS interface",
        body: "Built the SwiftUI shell, navigation, and component library in Xcode so engineering could plug in ARKit sessions and live API streams without redesigning screens.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1769221063/Screenshot_2026-01-23_at_9.17.37_PM_raqzba.png",
        caption: "App structure in Xcode — dependencies and screen map",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1769220305/look_back0001-0072_ffci2z.mp4",
        caption: "Blender pre-visualization of assistant in AR",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1769221622/Screen_Recording_2026-01-23_at_9.22.51_PM_qsy0dd.mov",
            caption: "Rive animation system for the assistant",
          },
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1769220289/IMG_5241_wu0tga.mov",
            caption: "Animation synced to voice input",
          },
        ],
      },
      {
        type: "text",
        title: "Integrations",
        body: "Supported Overshoot, Gemini, and LiveKit hooks for the hackathon demo and authored the public Devpost writeup.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1769222275/IMG_5214_d3mw7p.png",
        caption: "Submission snapshot — https://devpost.com/software/omni-hzxqra",
      },
    ],
  },
  {
    slug: "y-prize",
    title: "Y-Prize",
    category: "Strategy / Design",
    description: "Led design and prototyping for sustainable startup competition",
    visitUrl: "https://youtu.be/k8fP14yVEa8",
    thumbnail: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768447371/Screen_Recording_2026-01-14_at_10.20.36_PM_hfnucs.mov",
    },
    hero: {
      type: "youtube",
      src: "k8fP14yVEa8",
    },
    meta: {
      role: "Team Lead",
      collaborators: "Shaomin Kee, Corina Chen, Reine Huang, Joanne Lin",
      duration: "2025",
      tools: "Blender, Capcut, Microsoft PowerPoint, Google Slides",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Y-Prize is Penn's startup design competition. I led a five-person team through Y-Prize 2025, packaging a sustainable product narrative into a tight deck, a visual identity, Blender prototypes, and the five-minute cinematic pitch film that anchored our submission.",
      },
      {
        type: "text",
        title: "Pitch deck",
        body: "Five slides cover problem, solution, market, prototype, and ask — designed for legibility on a projector and PDF export.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768450142/Y-Prize_2025-images-0_lke54o.jpg",
            caption: "Deck slide 1 — problem framing",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768450145/Y-Prize_2025-images-1_n6vjy1.jpg",
            caption: "Deck slide 2 — solution",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768450143/Y-Prize_2025-images-2_z4j26i.jpg",
            caption: "Deck slide 3 — market",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768450144/Y-Prize_2025-images-3_c2ec4z.jpg",
            caption: "Deck slide 4 — prototype",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768450144/Y-Prize_2025-images-4_owz80v.jpg",
            caption: "Deck slide 5 — team & ask",
          },
        ],
      },
      {
        type: "text",
        title: "Pitch film",
        body: "The video above the writeup is the full five-minute pitch. Blender models were edited in CapCut with VO and music for submission.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768524628/Screenshot_2026-01-15_at_7.49.13_PM_vykmri.png",
        caption: "YouTube pitch — https://youtu.be/k8fP14yVEa8",
      },
    ],
  },
  {
    slug: "pawfond",
    title: "PawFond",
    category: "Product / Web",
    description: "Product design and web development for pet care startup",
    visitUrl: "https://mypawfond.com/",
    thumbnail: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451779/16oz_packaging_blue_fpowis.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451908/8oz_packagin_design_v2_ssbpjw.png",
    },
    heroVideo: {
      type: "video",
      src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768592032/pawfond_hero_u323pp.mov",
    },
    meta: {
      role: "Product Designer / Developer",
      collaborators: "PawFond Team",
      duration: "2025",
      tools: "Procreate, Adobe Fresco, Adobe Illustrator, Shopify",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "PawFond is a pet-care startup spanning physical product and DTC web. I owned packaging exploration and the Shopify storefront, translating brand sketches into trustworthy, shelf-ready dielines and a simple purchase path for first-time customers — a shoppable site the team can run without engineers on call.",
      },
      {
        type: "video",
        src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768526150/Screen_Recording_2026-01-15_at_8.10.29_PM_wdjscw.mov",
        caption: "Shopify theme build and product setup",
      },
      {
        type: "text",
        title: "Packaging system",
        body: "Explored 8 oz and 16 oz formats in blue-forward palettes, keeping typography readable at arm's length on shelf and in unboxing photos.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451908/8oz_packagin_design_v2_ssbpjw.png",
            caption: "8 oz — alternate layout v2",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451691/Untitled_Artwork_51_yd3pcx.png",
            caption: "Brand illustration explorations",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451889/8oz_packagin_design_blue_f01q6t.png",
            caption: "8 oz — blue primary",
          },
          {
            type: "image",
            src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451693/16oz_packaging_blue_t3tyfp.png",
            caption: "16 oz — production candidate",
          },
        ],
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768451779/16oz_packaging_blue_fpowis.png",
        caption: "16 oz hero SKU — thumbnail asset",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768526880/pawfond_display_7736b524-df3c-4f3a-ab41-ced9397e3db1_ywzt1a.webp",
        caption: "Retail display render",
      },
    ],
  },
  {
    slug: "rum-rush",
    title: "Rum Rush",
    category: "Game / 3D",
    description: "Game development leadership under schedule",
    thumbnail: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768527339/Rum_rush_thumbnail_z1x6cb.png",
    },
    hero: {
      type: "image",
      src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768552482/Screenshot_2026-01-16_at_3.34.33_AM_evwmzc.png",
    },
    meta: {
      role: "Producer / Team Lead",
      collaborators: "Rajas Nanda, Chris Wang, Andrew Han",
      duration: "2025",
      tools: "Unity, C#, Blender",
    },
    content: [
      {
        type: "text",
        title: "Overview",
        body: "Rum Rush is a time-manipulation action prototype built in Unity. As producer under a fixed schedule, I wrote the game design doc, planned milestones, and built hands-on systems (physics, ragdoll, audio, post) — keeping scope honest so the team could ship a vertical slice that still landed a distinctive feel: slow-mo combat, readable pickups, and punchy feedback.",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768552482/Screenshot_2026-01-16_at_3.34.33_AM_evwmzc.png",
        caption: "Unity graybox — bar and pickup layout",
      },
      {
        type: "image",
        src: "https://res.cloudinary.com/dak0zi45d/image/upload/v1768552649/Screenshot_2026-01-16_at_3.36.06_AM_jyqwts.png",
        caption: "Game design document — https://docs.google.com/document/d/1whl24mmz1ueF_pX9FL21w8iHkfytmpR0FFxYYhbG_nk/edit",
      },
      {
        type: "text",
        title: "Systems",
        body: "Core loops were proven with short capture clips before polish passes. Each system below was scoped to support the slow-time fantasy without bloating the build.",
      },
      {
        type: "gallery",
        columns: 1,
        items: [
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768552902/rigidbody_demo_rl2tpq.mov",
            caption: "Pickup and rigidbody interaction",
          },
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768553309/ragdoll_demo_rjzmdu.mov",
            caption: "Enemy ragdoll on impact",
          },
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768553492/mixer_demo_k224rc.mov",
            caption: "Dynamic audio mixer for slow-time",
          },
          {
            type: "video",
            src: "https://res.cloudinary.com/dak0zi45d/video/upload/v1768553724/post_processing_demo_mpbgvn.mov",
            caption: "Post-processing tied to slow-time",
          },
        ],
      },
    ],
  },
];

export const PLACEHOLDER_PROJECTS = [
  {
    slug: "hackprinceton-2026",
    title: "HackPrinceton 2026",
    placeholder: true,
  },
  {
    slug: "government-ui-project",
    title: "Government UI Project",
    placeholder: true,
  },
  {
    slug: "nasa-apps",
    title: "NASA Apps",
    placeholder: true,
  },
  {
    slug: "mosaic",
    title: "MOSAIC",
    placeholder: true,
  },
  {
    slug: "zipline",
    title: "Zipline",
    placeholder: true,
  },
  {
    slug: "minecraft",
    title: "Minecraft",
    placeholder: true,
  },
];

export const COLLECTIONS = {
  home: {
    title: "Home",
    intro:
      "Selected work across design, engineering, and interactive media — plus a few projects currently in progress.",
    slugs: [
      ...HOME_SLUGS,
      "hackprinceton-2026",
      "government-ui-project",
    ],
  },
  design: {
    slugs: ["orble-tea", "penn-electric-racing", "nasa-apps", "mosaic"],
  },
  graphics: {
    intro:
      "I've made many games on the Unity game engine, mostly focused on crafting detailed art styles. Recently, I've been pivoting to fast-production games with a goal to capture a playerbase.",
    links: [{ label: "itch.io", href: "https://al371160.itch.io/" }],
    slugs: [
      "clockwork-climb",
      "rum-rush",
      "saturn",
      "zipline",
      "minecraft",
    ],
  },
};

function findProject(slug) {
  return (
    projects.find((project) => project.slug === slug) ||
    PLACEHOLDER_PROJECTS.find((project) => project.slug === slug)
  );
}

export function collectionProjects(name) {
  return (COLLECTIONS[name]?.slugs || []).map(findProject).filter(Boolean);
}

export function homeProjects() {
  return collectionProjects("home");
}

export function moreWorkProjects() {
  const curated = new Set(
    Object.values(COLLECTIONS).flatMap((collection) => collection.slugs)
  );
  return projects.filter((project) => !curated.has(project.slug));
}
